import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import {
  makeButtonGroupOptionsFromEnum,
  makeSelectFieldOptionsFromEnum,
} from 'Common/FormHelper';

export const MealTypesOptions = makeButtonGroupOptionsFromEnum(MealTypesEnum);

export const SortByEnum = {
  Recipe: 'Recipe',
  Component: 'Component',
};

export const SortByOptions = makeSelectFieldOptionsFromEnum(SortByEnum);

export const ComponentEnum = {
  Fruit: 'Fruit',
  DarkGreenVegetables: 'DarkGreenVeg',
  RedOrangeVegetables: 'RedOrangeVeg',
  LegumesVegetables: 'LegumesVeg',
  StarchyVegetables: 'StarchyVeg',
  OtherVegetables: 'OtherVeg',
  AdditionalVegetables: 'AdditionalVeg',
  TotalVegetables: 'TotalVeg',
  TotalGrain: 'TotalGrain',
  MeatAlt: 'MeatAlt',
  Milk: 'Milk',
};

export const ComponentOptions = makeSelectFieldOptionsFromEnum(ComponentEnum);



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/helpers/FoodBasedAnalysisHelpers.js